import { CSSProperties, FC, ReactNode } from "react";
import classNames from "classnames";
import "./AilenaxBox.css";

interface AilenaxBoxProps {
    children: ReactNode;
    theme?: "none" | "rainbow" | "ice" | "fuerte" | "bavaria" | "halloween";
    className?: string;
    style?: CSSProperties;
}

export const AilenaxBox: FC<AilenaxBoxProps> = ({ children, theme = "rainbow", className, style }) => {
    const urlTheme = new URLSearchParams(globalThis.location.search).get('theme') ?? undefined;
    const realTheme = urlTheme ?? theme;

    return (
        <div className={classNames("ailenax-box", `theme-${realTheme}`, className)} style={style}>
            {children}
        </div>
    );
}